import { Type } from 'class-transformer';
import { ChangeDocumentOwnerRawDto } from './change-document-owner-raw-dto';

export class ChangeDocumentOwnerEditorResultDto {
    @Type(() => ChangeDocumentOwnerRawDto)
    changeOwnerInfo: ChangeDocumentOwnerRawDto;
    owner: string;
    propertyAddress: string;
}
